import { AuthContextProps } from "react-oidc-context";
import { configurationHelper } from "../configurationHelper";

export const authUtils = {
  Administrator: "Administrator",
  User: "User",
  Tester: "Tester",

  isAdministrator(auth: AuthContextProps): boolean {
    if (!auth.isAuthenticated) return false;

    const roles = (auth.user?.profile.roles ?? []) as string[];

    if (roles.length === 0) return false;

    return roles.indexOf(this.Administrator) >= 0;
  },

  isUser(auth: AuthContextProps): boolean {
    if (!auth.isAuthenticated) return false;

    const roles = (auth.user?.profile.roles ?? []) as string[];

    if (roles.length === 0) return false;

    // administrator is also user
    return (
      roles.indexOf(this.Administrator) >= 0 || roles.indexOf(this.User) >= 0
    );
  },

  isTester(auth: AuthContextProps): boolean {
    // testing only applicable for authenticated users in DEV
    if (!auth.isAuthenticated || !configurationHelper.isDevelopment())
      return false;

    const roles = (auth.user?.profile.roles ?? []) as string[];

    if (roles.length === 0) return false;

    return roles.indexOf(this.Tester) >= 0;
  },

  hasRole(auth: AuthContextProps, role: string): boolean {
    if (role === this.Administrator) return this.isAdministrator(auth);
    else if (role === this.User) return this.isUser(auth);
    else if (role === this.Tester) return this.isTester(auth);

    return false;
  },

  getName(auth: AuthContextProps): string {
    if (!auth.user) return "";

    const givenName = auth.user.profile.given_name ?? "";
    const surname = auth.user.profile.family_name ?? "";

    if (givenName !== "" && surname !== "") {
      return `${givenName} ${surname}`;
    }

    return auth.user.profile.name ?? "";
  },
};
